module.exports = __webpack_public_path__ + "static/media/noimage.1a12b4c6.png";